import { useSnackbar } from "notistack";
import React from "react";

export default function useCustomSnackbar() {
    const { enqueueSnackbar: defaultSnackbar, closeSnackbar } = useSnackbar();

    const enqueueSnackbar = React.useCallback((messageParam, configParam) => {
        const message = messageParam || "";
        const config = configParam || { variant: "error" }
        if (message)
            defaultSnackbar(message, config);
    }, [defaultSnackbar]);
    return { enqueueSnackbar, closeSnackbar };
}